export const NAV_LIST = [
  {
    label: 'Home',
    href: '/',
    key: 'home',
  },
  {
    label: 'Work',
    href: '/work',
    key: 'work',
  },
  {
    label: 'Daily UI',
    href: '/daily-ui',
    key: 'daily-ui',
  },
  {
    label: 'Graphic Design',
    href: '/graphic-design',
    key: 'graphic-design',
  },
];
